module.exports = function getResource(label, vars = []) {
    let resources = {
        size: `FORMAT ${vars[0]}`,
        item: `ARTICLE ${vars[0]}`
    };
    return resources[label];
};
